import React, { useState, useEffect, useRef } from "react";
import Button from "components/Button/Button";
import { ReactComponent as AddIcon } from "assets/add.svg";
import { useKPI } from "providers/KPIProvider";
import KPIForm from "./KPIForm";
import "./KPIModal.css";
import Loader from "components/Loader/Loader";

const defaultKPI = {
  _id: 0,
  name: "",
  target: "",
  startDate: null,
  endDate: null,
  nodeId: null,
};

const AddKPIModal = ({ show, nodeData, onClose }) => {
  const formRefs = useRef([]);
  const { getKPIByNodeId } = useKPI([]);
  const [kpis, setKPIs] = useState([]);
  const [kpiFormState, setKPIFormState] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  function addKPI() {
    if (kpis.length === 5) {
      return;
    }
    // console.log({ kpis });

    setKPIs((prevState) => [
      ...prevState,
      { ...defaultKPI, _id: prevState.length },
    ]);
  }

  // useEffect;

  function deleteKPIRow(id) {
    setKPIs((prevState) => prevState.filter((kpi) => kpi._id !== id));
    // setKPIs((prevState) =>
    //   prevState.map((data, index) => {
    //     return { ...data, _id: index };
    //   })
    // );
  }

  async function handleSubmit() {
    try {
      // setSubmitLoading(true);
      formRefs.current.forEach((ref) => {
        ref.current?.submitForm();
      });
      // await new Promise((resolve) => setTimeout(resolve, 2000));
    } catch (err) {
      console.error("submission error: ", err);
    }
  }

  function updateKPIFormState(id) {
    setKPIFormState((prevState) => ({ ...prevState, [id]: true }));
  }

  useEffect(() => {
    if (show && nodeData.nodeId) {
      setLoading(true);
      getKPIByNodeId(nodeData.nodeId)
        .then((res) => {
          setKPIs([...res.data, { ...defaultKPI, _id: res.data.length }]);
          setKPIFormState(
            res.data.reduce((acc, curr) => ({ ...acc, [curr._id]: false }), {
              0: false,
            })
          );
        })
        .catch((ex) => {
          console.log(ex);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [show, nodeData.nodeId, getKPIByNodeId]);

  useEffect(() => {
    if (
      Object.values(kpiFormState).length &&
      Object.values(kpiFormState).some((val) => val)
    ) {
      setSubmitLoading(false);
      onClose();
    }
  }, [kpiFormState, onClose]);

  useEffect(() => {
    formRefs.current = kpis.map((_, i) =>
      formRefs.current[i] ? formRefs.current[i] : React.createRef()
    );
  }, [kpis]);

  if (!show) {
    return null;
  }

  return (
    <div className="kpi-modal fixed inset-0 w-screen h-screen z-50 bg-black bg-opacity-80 font-inter">
      <div className="absolute max-w-[931px] inset-0 m-auto w-10/12 h-max bg-white rounded-[10px]">
        <header className="font-semibold text-start px-6 py-3">
          {nodeData.heading}
        </header>
        <div className="form-container mx-6 my-5 rounded-[10px]">
          <header className="form-header grid grid-flow-col auto-cols-fr ps-5 pe-12 py-3 gap-x-4 gap-y-3 font-semibold text-xs">
            <p>KPI Title</p>
            <p>KPI Target</p>
            <p>Start Date</p>
            <p>Time Period</p>
            <p>End Date</p>
          </header>
          {loading ? (
            <div className="mx-auto h-6 w-6 my-12 animate-spin rounded-full border-2 border-solid border-[#55C880] border-t-transparent"></div>
          ) : (
            kpis.slice(0, 5).map((kpi, index) => (
              <div
                key={kpi._id}
                className={`${
                  index !== kpis.length - 1 && "border-b border-[#D9D9D9]"
                }`}
              >
                <KPIForm
                  ref={formRefs.current[index]}
                  kpi={kpi.nodeId ? kpi : { ...kpi, nodeId: nodeData.nodeId }}
                  updateKPIFormState={updateKPIFormState}
                  deleteKPIRow={deleteKPIRow}
                  setKPIs={setKPIs}
                  kpiLength={kpis.length}
                  setSubmitLoading={setSubmitLoading}
                />
              </div>
            ))
          )}
          {kpis.length < 5 && !loading && (
            <div
              className={`${kpis.length === 0 && "flex justify-center py-5"}`}
            >
              <Button
                label="Add KPI"
                className="link text-xs"
                startSlot={<AddIcon />}
                onClick={() => addKPI()}
                disabled={kpis.length === 5}
              />
            </div>
          )}
        </div>
        <footer className="flex justify-between items-center font-semibold text-start text-sm px-6 py-3">
          <button className="outline-btn" type="submit" onClick={onClose}>
            Cancel
          </button>
          <button
            className="primary min-w-[88px] min-h-[33px]"
            type="button"
            onClick={handleSubmit}
            disabled={submitLoading}
          >
            {submitLoading ? <Loader /> : "Submit"}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default AddKPIModal;
